import {useQuery} from '@tanstack/react-query'

import {QueryKeyName, getSections} from '../../common/backend'

export const useSections = () => {
  return useQuery({
    queryKey: [QueryKeyName.GetSections],
    queryFn: () => getSections(),
    staleTime: Infinity
  })
}
